import React from 'react';
import { CheckCircle, Edit2, HandCoins, Save, Trash2, WalletCards } from 'lucide-react';

const VehicleVisitActions = ({
    visit,
    isEditing,
    setIsEditing,
    onCancel,
    isSaving,
    finalized,
    hasPayments,
    operationallyOpen,
    canDelete,
    canCollectCustomerPayment = false,
    isCollectingCustomerPayment = false,
    canAddCustomerAdvance = false,
    isAddingCustomerAdvance = false,
    onSave,
    onClose,
    onReopen,
    onDelete,
    onCollectCustomerPayment,
    onAddCustomerAdvance,
}) => {
    const canReopen = !finalized && !isEditing;
    const canRemove = canDelete && !finalized && !hasPayments;
    const isActiveVisit = !finalized && operationallyOpen;
    const actionClass = 'min-h-11 w-full sm:w-auto px-4 py-2 rounded-xl text-xs sm:text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-50 transition-[transform,background-color] duration-200 active:scale-95';

    return (
        <div
            className={`${isEditing ? 'vehicle-mobile-sticky-actions ' : ''}flex flex-col sm:flex-row sm:flex-wrap justify-end gap-2 pt-3`}
            style={{ borderTop: '1px solid rgba(203,213,225,0.8)' }}
            onClick={(event) => event.stopPropagation()}
            data-testid={`visit-actions-bar-${visit.id}`}
        >
            {isEditing && <>
                <button
                    type="button"
                    onClick={onCancel || (() => setIsEditing(false))}
                    className="min-h-11 w-full sm:w-auto px-4 py-2 rounded-xl text-xs sm:text-sm font-bold transition-[transform,background-color] duration-200 active:scale-95"
                    style={{ background: 'rgba(255,255,255,0.8)', border: '1px solid rgba(203,213,225,0.8)', color: 'rgba(71,85,105,0.95)' }}
                    data-testid={`visit-cancel-edit-${visit.id}`}
                    disabled={isSaving}
                >
                    إلغاء
                </button>
                <button
                    type="button"
                    onClick={onSave}
                    disabled={isSaving || finalized}
                    className={actionClass}
                    style={{ background: 'rgba(56,189,248,0.14)', border: '1px solid rgba(56,189,248,0.28)', color: 'rgba(3,105,161,0.95)' }}
                    data-testid={`visit-save-button-${visit.id}`}
                >
                    <Save size={14} /> {isSaving ? 'جاري الحفظ...' : 'حفظ'}
                </button>
                <button
                    type="button"
                    onClick={onClose}
                    disabled={isSaving || finalized}
                    className={actionClass}
                    style={{ background: 'rgba(16,185,129,0.14)', border: '1px solid rgba(16,185,129,0.28)', color: 'rgba(4,120,87,0.95)' }}
                    data-testid={`visit-close-button-${visit.id}`}
                >
                    <CheckCircle size={14} /> {isSaving ? 'جاري الإغلاق...' : 'حفظ وإغلاق'}
                </button>
            </>}

            {!isEditing && finalized && operationallyOpen && (
                <button
                    type="button"
                    onClick={onClose}
                    disabled={isSaving}
                    className={actionClass}
                    style={{ background: 'rgba(16,185,129,0.14)', border: '1px solid rgba(16,185,129,0.28)', color: 'rgba(4,120,87,0.95)' }}
                    data-testid={`visit-close-button-${visit.id}`}
                >
                    <CheckCircle size={14} /> {isSaving ? 'جاري الإغلاق...' : 'إغلاق الزيارة'}
                </button>
            )}

            {canCollectCustomerPayment && (
                <button
                    type="button"
                    onClick={onCollectCustomerPayment}
                    disabled={isSaving || isCollectingCustomerPayment}
                    className={actionClass}
                    style={{ background: 'rgba(14,165,233,0.14)', border: '1px solid rgba(14,165,233,0.30)', color: 'rgba(3,105,161,0.95)' }}
                    data-testid={`visit-collect-customer-payment-${visit.id}`}
                >
                    <WalletCards size={14} /> {isCollectingCustomerPayment ? 'جارٍ تسجيل التحصيل...' : 'تحصيل العميل'}
                </button>
            )}

            {canAddCustomerAdvance && (
                <button
                    type="button"
                    onClick={onAddCustomerAdvance}
                    disabled={isSaving || isAddingCustomerAdvance}
                    className={actionClass}
                    style={{ background: 'rgba(139,92,246,0.12)', border: '1px solid rgba(139,92,246,0.28)', color: 'rgba(109,40,217,0.95)' }}
                    data-testid={`visit-add-customer-advance-${visit.id}`}
                    title="تسجيل دفعة مقدمة لصالح العميل"
                    aria-label="إضافة دفعة مقدمة لصالح العميل"
                >
                    <HandCoins size={14} /> {isAddingCustomerAdvance ? 'جارٍ تسجيل الدفعة...' : 'إضافة دفعة مقدمة'}
                </button>
            )}

            {canReopen && (
                <button
                    type="button"
                    onClick={isActiveVisit ? () => setIsEditing(true) : onReopen}
                    className={actionClass}
                    style={{ background: 'rgba(245,158,11,0.14)', border: '1px solid rgba(245,158,11,0.28)', color: 'rgba(180,83,9,0.95)' }}
                    data-testid={`visit-reopen-button-${visit.id}`}
                >
                    <Edit2 size={14} /> {isActiveVisit ? 'تعديل البنود' : 'إعادة فتح لتعديل البنود'}
                </button>
            )}

            {canRemove && (
                <button
                    type="button"
                    onClick={() => onDelete?.(visit.id)}
                    className="w-full sm:w-auto px-4 py-2 rounded-xl text-xs font-bold flex items-center justify-center gap-2"
                    style={{ background: 'rgba(244,63,94,0.12)', border: '1px solid rgba(244,63,94,0.28)', color: 'rgba(159,18,57,0.95)' }}
                    data-testid={`visit-delete-button-${visit.id}`}
                >
                    <Trash2 size={14} /> حذف الزيارة
                </button>
            )}
        </div>
    );
};

export default VehicleVisitActions;
